const COLORS = require("../data/colors.js");
const THREE = require("three");
const UTILS = require("./utils.js");
const config = require("../config.js");
var m;
var q;
const u = [
  {
    stp: 0,
    col: null,
  },
  {
    stp: 0.5,
    col: null,
  },
  {
    stp: 1,
    col: null,
  },
];
class v extends THREE.Object3D {
  static fromConfig(w, x) {
    return new v(
      w.zoneSize,
      w.zoneSpeed,
      w.zoneRnd,
      w.zoneCol0,
      w.zoneCol1,
      w.zoneCol2,
      x,
    );
  }
  constructor(w, x, y, z, A, B, C) {
    super();
    this.isClient = !!C;
    this.randomEndPoint = !!y;
    this._size = UTILS.limitMM(w || 50, config.minZoneSize, config.maxZoneSize);
    this.circleSize = new THREE.Vector3();
    this.circlePosition = new THREE.Vector3();
    this.targetCircleSize = new THREE.Vector3();
    this.targetCirclePosition = new THREE.Vector3();
    this.circleShrinkSpeed =
      UTILS.limitMM(x || 1, config.minShrinkSpeed, config.maxShrinkSpeed) * 2.5;
    if (C) {
      m ||= new THREE.TextureLoader().load(
        UTILS.assetsUrl("/textures/zone_0.png"),
        (K) => {
          K.wrapS = THREE.RepeatWrapping;
          K.wrapT = THREE.RepeatWrapping;
          K.minFilter = THREE.NearestFilter;
          K.magFilter = THREE.NearestFilter;
          K.repeat.set(20, 20);
          K.needsUpdate = true;
        },
      );
      q ||= new THREE.MeshBasicMaterial({
        color: 16777215,
        depthWrite: false,
        flatShading: false,
        map: m,
        vertexColors: THREE.VertexColors,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.5,
      });
      u[0].col = new THREE.Color(z || COLORS.zones.BR[0]);
      u[1].col = new THREE.Color(A || COLORS.zone.BR[1]);
      u[2].col = new THREE.Color(B || COLORS.zone.BR[2]);
      let E = new THREE.CylinderGeometry(1, 1, 1, 32, 32, true);
      E.computeBoundingBox();
      let F = E.boundingBox;
      let G = new THREE.Vector3().subVectors(F.max, F.min);
      let H = ["a", "b", "c"];
      let I = new THREE.Vector3();
      let J = 0;
      for (let K, L = 0; L < u.length - 1; L++) {
        K = u[L + 1].stp - u[L].stp;
        for (let M, N = 0; N < E.faces.length; N++) {
          M = E.faces[N];
          for (var D = 0; D < 3; D++) {
            J = I.subVectors(E.vertices[M[H[D]]], F.min).divide(G).y;
            J = 1 - J;
            if (J >= u[L].stp && J <= u[L + 1].stp) {
              M.vertexColors[D] = u[L].col
                .clone()
                .lerp(u[L + 1].col, (J - u[L].stp) / K);
            }
          }
        }
      }
      E.computeVertexNormals(true);
      E.computeFaceNormals();
      this.baseMesh = new THREE.Mesh(E, q);
    }
    this.reset();
    if (C) {
      this.add(this.baseMesh);
    }
  }
  animate(w) {
    if (this.baseMesh && this.baseMesh.material.map) {
      this.baseMesh.material.map.offset.y += w * 0.00003;
    }
  }
  update(w, x) {
    if (this.isClient) {
      if (this.shrinkTween) {
        this.shrinkTween.stop();
      }
      this.shrinkTween = new TWEEN.Tween(this.scale)
        .to(
          {
            x: x[2],
            z: x[3],
          },
          900,
        )
        .easing(TWEEN.Easing.Linear.None)
        .start();
      if (this.moveTween) {
        this.moveTween.stop();
      }
      this.moveTween = new TWEEN.Tween(this.position)
        .to(
          {
            x: x[0],
            z: x[1],
          },
          900,
        )
        .easing(TWEEN.Easing.Linear.None)
        .start();
      if (x[2] <= 0 || x[3] <= 0) {
        this.visible = false;
      }
    } else {
      if (this.circleSize.x <= 0 && this.circleSize.z <= 0) {
        return;
      }
      var y = new THREE.Vector3()
        .subVectors(this.targetCircleSize, this.circleSize)
        .normalize();
      var z = new THREE.Vector3().addVectors(
        this.circleSize,
        y.multiplyScalar(w * this.circleShrinkSpeed),
      );
      var A = new THREE.Vector3()
        .subVectors(this.targetCirclePosition, this.circlePosition)
        .normalize();
      var B = new THREE.Vector3().addVectors(
        this.circlePosition,
        A.multiplyScalar(w * this.circleShrinkSpeed),
      );
      this.setCircleSize(B, z);
    }
  }
  generateTargetCircle() {
    if (!this.randomEndPoint) {
      return [0, 0];
    }
    var w = Math.random() * 2 * Math.PI;
    var x = (this._size / 2) * Math.sqrt(Math.random());
    return [x * Math.cos(w), x * Math.sin(w)];
  }
  setCircleSize(w, x) {
    this.circlePosition = w;
    this.circleSize = x;
  }
  setTargetCircle(w, x) {
    this.targetCirclePosition = w;
    this.targetCircleSize = x;
  }
  getData() {
    return [
      this.circlePosition.x,
      this.circlePosition.z,
      this.circleSize.x,
      this.circleSize.z,
    ];
  }
  reset() {
    if (this.isClient) {
      this.scale.set(this._size, 1000, this._size);
      this.position.set(0, 0, 0);
      this.visible = true;
    } else {
      this.setCircleSize(
        new THREE.Vector3(0, 0, 0),
        new THREE.Vector3(this._size, 1000, this._size),
      );
      var w = this.generateTargetCircle();
      this.setTargetCircle(
        new THREE.Vector3(w[0], 0, w[1]),
        new THREE.Vector3(0, 0, 0),
      );
    }
  }
  isOutside(w) {
    return (
      UTILS.distance2D(w.x, w.z, this.circlePosition.x, this.circlePosition.z) >
      this.circleSize.x
    );
  }
}
v.CONFIG_PROPS = [
  "zoneSize",
  "zoneSpeed",
  "zoneRnd",
  "zoneCol0",
  "zoneCol1",
  "zoneCol2",
];
module.exports = v;
